export default class ContactFormClient {
    constructor(client, language) {
        this.client = client;
        this.language = language;
    }

    save(params) {
        return this.client.post(
            `/v2/${this.language.getCurrentLanguage()}/contact-form/rest/v1/contacts`,
            params,
        );
    }
}
